import { createUmi } from '@metaplex-foundation/umi-bundle-defaults'
import { walletAdapterIdentity } from '@metaplex-foundation/umi-signer-wallet-adapters'
import { mplTokenMetadata } from '@metaplex-foundation/mpl-token-metadata'
import { useWallet } from '@solana/wallet-adapter-react'
import { useMemo } from 'react'
import {
  CONNECTION_COMMITMENT,
  makeRpcUrlsFromStorageWithFallback,
  RPC_PROVIDER_URL_KEY_WITHOUT_DEFAULT,
} from '../utils/constants'
import { useLocalStorage } from './useLocalStorageState'

const useUmi = () => {
  const [rpcUrlFromStorage] = useLocalStorage(
    RPC_PROVIDER_URL_KEY_WITHOUT_DEFAULT,
  )
  const wallet = useWallet()
  return useMemo(() => {
    const { url, wsUrl } = makeRpcUrlsFromStorageWithFallback(rpcUrlFromStorage)

    return createUmi(url, {
      wsEndpoint: wsUrl,
      commitment: CONNECTION_COMMITMENT,
    })
      .use(mplTokenMetadata())
      .use(walletAdapterIdentity(wallet))
  }, [rpcUrlFromStorage, wallet])
}

export default useUmi
